import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';

type Language = 'ru' | 'en';

interface Translations {
  [key: string]: {
    ru: string;
    en: string;
  };
}

const translations: Translations = {
  // Навигация
  'nav.menu': { ru: 'Блюда', en: 'Menu' },
  'nav.orders': { ru: 'Заказы', en: 'Orders' },
  'nav.promoCodes': { ru: 'Промокоды', en: 'Promo Codes' },
  'nav.employees': { ru: 'Сотрудники', en: 'Employees' },
  'nav.battleship': { ru: 'Поиск сокровищ', en: 'Treasure Hunt' },
  'nav.treasureHuntGeneration': { ru: 'Поиск сокровищ', en: 'Treasure Hunt' },
  'nav.safeCracking': { ru: 'Взлом сейфа', en: 'Safe Cracking' },
  'nav.simulation': { ru: 'Симуляция', en: 'Simulation' },
  'nav.about': { ru: 'О нас', en: 'About' },
  'nav.logout': { ru: 'Выйти', en: 'Logout' },
  'nav.administrator': { ru: 'Администратор', en: 'Administrator' },

  // Страница входа
  'login.title': { ru: 'Вход в систему', en: 'Login' },
  'login.username': { ru: 'Имя пользователя', en: 'Username' },
  'login.password': { ru: 'Пароль', en: 'Password' },
  'login.submit': { ru: 'Войти', en: 'Login' },
  'login.loading': { ru: 'Вход...', en: 'Logging in...' },
  'login.demo': { ru: 'Демо: admin / admin123', en: 'Demo: admin / admin123' },
  'login.error': { ru: 'Ошибка входа', en: 'Login error' },
  'login.errorInvalidCredentials': { ru: 'Неверные учетные данные', en: 'Invalid credentials' },
  'login.errorValidation': { ru: 'Ошибка валидации', en: 'Validation error' },
  'login.errorFillFields': { ru: 'Пожалуйста, заполните все поля', en: 'Please fill all fields' },
  'login.success': { ru: 'Успешный вход', en: 'Login successful' },
  'login.welcome': { ru: 'Добро пожаловать!', en: 'Welcome!' },

  // Общие
  'loading': { ru: 'Загрузка...', en: 'Loading...' },
  'welcome': { ru: 'Добро пожаловать', en: 'Welcome' },

  // Страница взлома сейфа
  'safeCracking.title': { ru: 'Взлом сейфа', en: 'Safe Cracking' },
  'safeCracking.subtitle': { ru: 'Интерактивная игра по взлому сейфа', en: 'Interactive safe cracking game' },
  'safeCracking.comingSoon': { ru: 'Скоро здесь появится игра!', en: 'Game coming soon!' },
  'safeCracking.description': { ru: 'Здесь будет увлекательная игра по взлому сейфа с различными уровнями сложности и загадками.', en: 'Here will be an exciting safe cracking game with various difficulty levels and puzzles.' },

  // Страница промокодов
  'promoCodes.title': { ru: 'Промокоды', en: 'Promo Codes' },
  'promoCodes.subtitle': { ru: 'Управление промокодами для скидок и акций', en: 'Manage promo codes for discounts and promotions' },
  'promoCodes.statistics': { ru: 'Статистика', en: 'Statistics' },
  'promoCodes.totalPromoCodes': { ru: 'Всего промокодов', en: 'Total Promo Codes' },
  'promoCodes.monthlyOrders': { ru: 'Заказов (месяц)', en: 'Orders (monthly)' },
  'promoCodes.monthlyDishesOrdered': { ru: 'Блюд заказано (месяц)', en: 'Dishes Ordered (monthly)' },
  'promoCodes.showActive': { ru: 'Показать активные', en: 'Show Active' },
  'promoCodes.showArchived': { ru: 'Показать архивные', en: 'Show Archived' },
  'promoCodes.addNew': { ru: 'Добавить промокод', en: 'Add Promo Code' },
  'promoCodes.cancel': { ru: 'Отмена', en: 'Cancel' },
  'promoCodes.formTitle': { ru: 'Новый промокод', en: 'New Promo Code' },
  'promoCodes.fieldName': { ru: 'Название', en: 'Name' },
  'promoCodes.fieldCode': { ru: 'Промокод', en: 'Promo Code' },
  'promoCodes.fieldDiscount': { ru: 'Скидка (%)', en: 'Discount (%)' },
  'promoCodes.placeholderName': { ru: 'Летняя распродажа', en: 'Summer Sale' },
  'promoCodes.placeholderCode': { ru: 'SUMMER2025', en: 'SUMMER2025' },
  'promoCodes.create': { ru: 'Создать', en: 'Create' },
  'promoCodes.columnName': { ru: 'Название', en: 'Name' },
  'promoCodes.columnCode': { ru: 'Промокод', en: 'Promo Code' },
  'promoCodes.columnOrders': { ru: 'Заказов (месяц)', en: 'Orders (monthly)' },
  'promoCodes.columnDishesOrdered': { ru: 'Блюд заказано (месяц)', en: 'Dishes Ordered (monthly)' },
  'promoCodes.columnDiscount': { ru: 'Скидка', en: 'Discount' },
  'promoCodes.columnStatus': { ru: 'Статус', en: 'Status' },
  'promoCodes.columnActions': { ru: 'Действия', en: 'Actions' },
  'promoCodes.statusActive': { ru: 'Активен', en: 'Active' },
  'promoCodes.statusArchived': { ru: 'Архив', en: 'Archived' },
  'promoCodes.actionArchive': { ru: 'В архив', en: 'Archive' },
  'promoCodes.actionActivate': { ru: 'Активировать', en: 'Activate' },
  'promoCodes.actionDelete': { ru: 'Удалить', en: 'Delete' },
  'promoCodes.actionCopy': { ru: 'Скопировать', en: 'Copy' },
  'promoCodes.copied': { ru: 'Скопировано!', en: 'Copied!' },
  'promoCodes.discount': { ru: 'Скидка', en: 'Discount' },
  'promoCodes.noActive': { ru: 'Нет активных промокодов', en: 'No active promo codes' },
  'promoCodes.noArchived': { ru: 'Нет архивных промокодов', en: 'No archived promo codes' },
  'promoCodes.success': { ru: 'Успешно', en: 'Success' },
  'promoCodes.successCreated': { ru: 'Промокод создан', en: 'Promo code created' },
  'promoCodes.successArchived': { ru: 'Промокод перемещен в архив', en: 'Promo code archived' },
  'promoCodes.successActivated': { ru: 'Промокод активирован', en: 'Promo code activated' },
  'promoCodes.successCopied': { ru: 'Промокод скопирован в буфер обмена', en: 'Promo code copied to clipboard' },
  'promoCodes.error': { ru: 'Ошибка', en: 'Error' },
  'promoCodes.errorLoadFailed': { ru: 'Не удалось загрузить промокоды', en: 'Failed to load promo codes' },
  'promoCodes.errorCreateFailed': { ru: 'Не удалось создать промокод', en: 'Failed to create promo code' },
  'promoCodes.errorUpdateFailed': { ru: 'Не удалось обновить промокод', en: 'Failed to update promo code' },
  'promoCodes.errorValidation': { ru: 'Ошибка валидации', en: 'Validation error' },
  'promoCodes.errorFillAllFields': { ru: 'Заполните все поля', en: 'Fill all fields' },
  'promoCodes.errorDiscountTooHigh': { ru: 'Скидка не может быть больше 100%', en: 'Discount cannot exceed 100%' },
  'promoCodes.errorCodeExists': { ru: 'Промокод с таким кодом уже существует', en: 'Promo code with this code already exists' },
  'promoCodes.level': { ru: 'Уровень', en: 'Level' },
  'promoCodes.level1': { ru: '1-й уровень', en: 'Level 1' },
  'promoCodes.level2': { ru: '2-й уровень', en: 'Level 2' },
  'promoCodes.fieldLevel': { ru: 'Уровень промокода', en: 'Promo Code Level' },
  'promoCodes.fieldParentPromo': { ru: 'Родительский промокод', en: 'Parent Promo Code' },
  'promoCodes.selectParentPromo': { ru: 'Выберите промокод 1-го уровня', en: 'Select Level 1 Promo Code' },
  'promoCodes.noParentAvailable': { ru: 'Нет доступных промокодов 1-го уровня', en: 'No Level 1 promo codes available' },
  'promoCodes.parentPromo': { ru: 'Родительский промокод', en: 'Parent Promo' },
  'promoCodes.points': { ru: 'Баллы', en: 'Points' },
  'promoCodes.ordersCount': { ru: 'Заказов', en: 'Orders' },
  'promoCodes.editPoints': { ru: 'Редактировать баллы', en: 'Edit points' },
  'promoCodes.editPointsTitle': { ru: 'Редактирование баллов', en: 'Edit Points' },
  'promoCodes.fieldPoints': { ru: 'Количество баллов', en: 'Points Amount' },
  'promoCodes.currentPoints': { ru: 'Текущие баллы', en: 'Current Points' },
  'promoCodes.save': { ru: 'Сохранить', en: 'Save' },
  'promoCodes.successPointsUpdated': { ru: 'Баллы обновлены', en: 'Points updated' },
  'promoCodes.errorUpdatePointsFailed': { ru: 'Не удалось обновить баллы', en: 'Failed to update points' },
  'promoCodes.errorPointsNegative': { ru: 'Баллы не могут быть отрицательными', en: 'Points cannot be negative' },
  'promoCodes.viewOrders': { ru: 'История заказов', en: 'Order History' },
  'promoCodes.ordersHistory': { ru: 'История заказов по промокоду', en: 'Promo Code Order History' },
  'promoCodes.noOrders': { ru: 'Заказов с этим промокодом пока нет', en: 'No orders with this promo code yet' },
  'promoCodes.errorLoadOrdersFailed': { ru: 'Не удалось загрузить заказы', en: 'Failed to load orders' },

  // Страница Морской бой (переделанная в сундуки)
  'battleship.title': { ru: 'Поиск сокровищ', en: 'Treasure Hunt' },
  'battleship.subtitle': { ru: 'Найдите все спрятанные сундуки на карте', en: 'Find all hidden treasure chests on the map' },
  'battleship.generateField': { ru: 'Генерировать поле', en: 'Generate Field' },
  'battleship.showConfig': { ru: 'Показать настройки', en: 'Show Configuration' },
  'battleship.hideConfig': { ru: 'Скрыть настройки', en: 'Hide Configuration' },
  'battleship.resetConfig': { ru: 'Сбросить настройки', en: 'Reset Configuration' },
  'battleship.configuration': { ru: 'Настройки игры', en: 'Game Configuration' },
  'battleship.gridSize': { ru: 'Размер поля', en: 'Grid Size' },
  'battleship.gridSizeHint': { ru: 'Размер от 5 до 20 клеток', en: 'Size from 5 to 20 cells' },
  'battleship.chestsCount': { ru: 'Количество сундуков', en: 'Chests Count' },
  'battleship.chestsCountHint': { ru: 'Количество сундуков для размещения на карте', en: 'Number of chests to place on the map' },
  'battleship.chestsInfo': { ru: 'Информация о сундуках', en: 'Chests Information' },
  'battleship.chestLabel': { ru: 'Сундук с сокровищами', en: 'Treasure Chest' },
  'battleship.totalCells': { ru: 'Всего клеток', en: 'Total cells' },
  'battleship.success': { ru: 'Успешно', en: 'Success' },
  'battleship.successFieldGenerated': { ru: 'Поле успешно сгенерировано', en: 'Field generated successfully' },
  'battleship.successConfigReset': { ru: 'Настройки сброшены на стандартные', en: 'Configuration reset to default' },
  'battleship.error': { ru: 'Ошибка', en: 'Error' },
  'battleship.errorTooManyChests': { ru: 'Слишком много сундуков для данного размера поля', en: 'Too many chests for this grid size' },
  'battleship.errorNotEnoughChests': { ru: 'Необходимо хотя бы один сундук', en: 'At least one chest is required' },

  // Страница сотрудников
  'employees.title': { ru: 'Сотрудники', en: 'Employees' },
  'employees.subtitle': { ru: 'Управление списком сотрудников ресторана', en: 'Manage restaurant staff list' },
  'employees.activeCount': { ru: 'Активных сотрудников', en: 'Active Employees' },
  'employees.archivedCount': { ru: 'В архиве', en: 'Archived' },
  'employees.showActive': { ru: 'Показать активных', en: 'Show Active' },
  'employees.showArchived': { ru: 'Показать архив', en: 'Show Archived' },
  'employees.addNew': { ru: 'Добавить сотрудника', en: 'Add Employee' },
  'employees.cancel': { ru: 'Отмена', en: 'Cancel' },
  'employees.formTitle': { ru: 'Новый сотрудник', en: 'New Employee' },
  'employees.fieldName': { ru: 'Имя сотрудника', en: 'Employee Name' },
  'employees.placeholderName': { ru: 'Иван Иванов', en: 'John Doe' },
  'employees.create': { ru: 'Создать', en: 'Create' },
  'employees.columnName': { ru: 'Имя сотрудника', en: 'Employee Name' },
  'employees.columnCreatedAt': { ru: 'Дата добавления', en: 'Created At' },
  'employees.columnStatus': { ru: 'Статус', en: 'Status' },
  'employees.columnActions': { ru: 'Действия', en: 'Actions' },
  'employees.statusActive': { ru: 'Активен', en: 'Active' },
  'employees.statusArchived': { ru: 'Архив', en: 'Archived' },
  'employees.actionArchive': { ru: 'В архив', en: 'Archive' },
  'employees.actionActivate': { ru: 'Активировать', en: 'Activate' },
  'employees.noActive': { ru: 'Нет активных сотрудников', en: 'No active employees' },
  'employees.noArchived': { ru: 'Нет архивных сотрудников', en: 'No archived employees' },
  'employees.success': { ru: 'Успешно', en: 'Success' },
  'employees.successCreated': { ru: 'Сотрудник добавлен', en: 'Employee added' },
  'employees.successArchived': { ru: 'Сотрудник перемещен в архив', en: 'Employee archived' },
  'employees.successActivated': { ru: 'Сотрудник активирован', en: 'Employee activated' },
  'employees.error': { ru: 'Ошибка', en: 'Error' },
  'employees.errorLoadFailed': { ru: 'Не удалось загрузить сотрудников', en: 'Failed to load employees' },
  'employees.errorCreateFailed': { ru: 'Не удалось создать сотрудника', en: 'Failed to create employee' },
  'employees.errorUpdateFailed': { ru: 'Не удалось обновить статус', en: 'Failed to update status' },
  'employees.errorValidation': { ru: 'Ошибка валидации', en: 'Validation error' },
  'employees.errorFillAllFields': { ru: 'Заполните все поля', en: 'Fill all fields' },

  // Страница меню
  'menu.title': { ru: 'Блюда', en: 'Menu' },
  'menu.subtitle': { ru: 'Меню и управление блюдами', en: 'Menu and dishes management' },
  'menu.addNew': { ru: 'Добавить блюдо', en: 'Add Dish' },
  'menu.columnImage': { ru: 'Изображение', en: 'Image' },
  'menu.columnName': { ru: 'Название', en: 'Name' },
  'menu.columnPortions': { ru: 'Граммовки и цены', en: 'Portions and Prices' },
  'menu.columnActions': { ru: 'Действия', en: 'Actions' },
  'menu.actionEdit': { ru: 'Редактировать', en: 'Edit' },
  'menu.actionDelete': { ru: 'Удалить', en: 'Delete' },
  'menu.noDishes': { ru: 'Нет блюд', en: 'No dishes' },
  'menu.noPortions': { ru: 'Нет граммовок', en: 'No portions' },
  'menu.modalTitle': { ru: 'Новое блюдо', en: 'New Dish' },
  'menu.fieldName': { ru: 'Название блюда', en: 'Dish Name' },
  'menu.fieldImage': { ru: 'Изображение', en: 'Image' },
  'menu.placeholderName': { ru: 'Например: Борщ', en: 'e.g.: Borscht' },
  'menu.imageHint': { ru: 'JPG, PNG, GIF или WEBP (макс. 5МБ)', en: 'JPG, PNG, GIF or WEBP (max 5MB)' },
  'menu.cancel': { ru: 'Отмена', en: 'Cancel' },
  'menu.create': { ru: 'Создать', en: 'Create' },
  'menu.creating': { ru: 'Создание...', en: 'Creating...' },
  'menu.success': { ru: 'Успешно', en: 'Success' },
  'menu.successCreated': { ru: 'Блюдо создано', en: 'Dish created' },
  'menu.successDeleted': { ru: 'Блюдо удалено', en: 'Dish deleted' },
  'menu.error': { ru: 'Ошибка', en: 'Error' },
  'menu.errorLoadFailed': { ru: 'Не удалось загрузить блюда', en: 'Failed to load dishes' },
  'menu.errorCreateFailed': { ru: 'Не удалось создать блюдо', en: 'Failed to create dish' },
  'menu.errorDeleteFailed': { ru: 'Не удалось удалить блюдо', en: 'Failed to delete dish' },
  'menu.errorValidation': { ru: 'Ошибка валидации', en: 'Validation error' },
  'menu.errorFillAllFields': { ru: 'Заполните все поля', en: 'Fill all fields' },
  'menu.confirmDelete': { ru: 'Вы уверены, что хотите удалить это блюдо?', en: 'Are you sure you want to delete this dish?' },
  'menu.actionPrices': { ru: 'Цены', en: 'Prices' },
  'menu.noPricesHint': { ru: 'Добавьте граммовки для редактирования цен', en: 'Add portions to edit prices' },
  'menu.pricesModalTitle': { ru: 'Редактирование цен', en: 'Edit Prices' },
  'menu.pricesModalSubtitle': { ru: 'Установите цены и видимость для различных источников заказов', en: 'Set prices and visibility for different order sources' },

  // Страница редактирования блюда
  'dishEdit.title': { ru: 'Редактирование блюда', en: 'Edit Dish' },
  'dishEdit.subtitle': { ru: 'Изменение информации о блюде и управление граммовками', en: 'Edit dish information and manage portions' },
  'dishEdit.backToMenu': { ru: 'Назад к меню', en: 'Back to Menu' },
  'dishEdit.sectionBasicInfo': { ru: 'Основная информация', en: 'Basic Information' },
  'dishEdit.sectionPortions': { ru: 'Граммовки', en: 'Portions' },
  'dishEdit.fieldImage': { ru: 'Изображение блюда', en: 'Dish Image' },
  'dishEdit.fieldName': { ru: 'Название блюда', en: 'Dish Name' },
  'dishEdit.placeholderName': { ru: 'Например: Борщ', en: 'e.g.: Borscht' },
  'dishEdit.imageHint': { ru: 'JPG, PNG, GIF или WEBP (макс. 5МБ)', en: 'JPG, PNG, GIF or WEBP (max 5MB)' },
  'dishEdit.saveChanges': { ru: 'Сохранить изменения', en: 'Save Changes' },
  'dishEdit.placeholderWeight': { ru: 'Например: 250', en: 'e.g.: 250' },
  'dishEdit.weightHint': { ru: 'Введите вес порции в граммах', en: 'Enter portion weight in grams' },
  'dishEdit.addPortion': { ru: 'Добавить граммовку', en: 'Add Portion' },
  'dishEdit.noPortions': { ru: 'Нет граммовок. Добавьте первую!', en: 'No portions. Add the first one!' },
  'dishEdit.existingPortions': { ru: 'Существующие граммовки', en: 'Existing Portions' },
  'dishEdit.grams': { ru: 'г', en: 'g' },
  'dishEdit.deletePortion': { ru: 'Удалить', en: 'Delete' },
  'dishEdit.success': { ru: 'Успешно', en: 'Success' },
  'dishEdit.successUpdated': { ru: 'Блюдо обновлено', en: 'Dish updated' },
  'dishEdit.successPortionAdded': { ru: 'Граммовка добавлена', en: 'Portion added' },
  'dishEdit.successPortionDeleted': { ru: 'Граммовка удалена', en: 'Portion deleted' },
  'dishEdit.error': { ru: 'Ошибка', en: 'Error' },
  'dishEdit.errorLoadFailed': { ru: 'Не удалось загрузить блюдо', en: 'Failed to load dish' },
  'dishEdit.errorUpdateFailed': { ru: 'Не удалось обновить блюдо', en: 'Failed to update dish' },
  'dishEdit.errorPortionAddFailed': { ru: 'Не удалось добавить граммовку', en: 'Failed to add portion' },
  'dishEdit.errorPortionDeleteFailed': { ru: 'Не удалось удалить граммовку', en: 'Failed to delete portion' },
  'dishEdit.errorValidation': { ru: 'Ошибка валидации', en: 'Validation error' },
  'dishEdit.errorFillAllFields': { ru: 'Заполните все поля', en: 'Fill all fields' },
  'dishEdit.errorInvalidWeight': { ru: 'Введите корректный вес', en: 'Enter valid weight' },
  'dishEdit.errorDuplicateWeight': { ru: 'Граммовка с таким весом уже существует', en: 'Portion with this weight already exists' },

  // Компонент таблицы цен на граммовки
  'portionPrices.columnPortion': { ru: 'Граммовка', en: 'Portion' },
  'portionPrices.grams': { ru: 'г', en: 'g' },
  'portionPrices.visible': { ru: 'Видимо', en: 'Visible' },
  'portionPrices.hidden': { ru: 'Скрыто', en: 'Hidden' },
  'portionPrices.save': { ru: 'Сохранить', en: 'Save' },
  'portionPrices.cancel': { ru: 'Отмена', en: 'Cancel' },
  'portionPrices.promoLabel': { ru: 'Промо', en: 'Promo' },
  'portionPrices.discountLabel': { ru: 'Скидка', en: 'Discount' },
  'portionPrices.allowPromo': { ru: 'Разрешены промокоды', en: 'Promo codes allowed' },
  'portionPrices.allowDiscount': { ru: 'Разрешены скидки на товар', en: 'Item discounts allowed' },
  'portionPrices.noPortions': { ru: 'Нет граммовок для отображения', en: 'No portions to display' },
  'portionPrices.noSources': { ru: 'Нет источников для отображения', en: 'No sources to display' },
  'portionPrices.success': { ru: 'Успешно', en: 'Success' },
  'portionPrices.successPriceUpdated': { ru: 'Цена обновлена', en: 'Price updated' },
  'portionPrices.successVisibilityUpdated': { ru: 'Видимость обновлена', en: 'Visibility updated' },
  'portionPrices.successPromoUpdated': { ru: 'Настройка промокода обновлена', en: 'Promo setting updated' },
  'portionPrices.successDiscountUpdated': { ru: 'Настройка скидки обновлена', en: 'Discount setting updated' },
  'portionPrices.error': { ru: 'Ошибка', en: 'Error' },
  'portionPrices.errorUpdateFailed': { ru: 'Не удалось обновить', en: 'Failed to update' },
  'portionPrices.errorValidation': { ru: 'Ошибка валидации', en: 'Validation error' },
  'portionPrices.errorInvalidPrice': { ru: 'Введите корректную цену', en: 'Enter valid price' },
  'portionPrices.clickToToggle': { ru: 'Нажмите, чтобы переключить', en: 'Click to toggle' },

  // Страница заказов
  'orders.title': { ru: 'Заказы', en: 'Orders' },
  'orders.subtitle': { ru: 'Управление заказами ресторана', en: 'Manage restaurant orders' },
  'orders.createNew': { ru: 'Создать заказ', en: 'Create Order' },
  'orders.table': { ru: 'Стол', en: 'Table' },
  'orders.dishes': { ru: 'Блюда', en: 'Dishes' },
  'orders.total': { ru: 'Итого', en: 'Total' },
  'orders.statusNew': { ru: 'Новый', en: 'New' },
  'orders.statusInProgress': { ru: 'В процессе', en: 'In Progress' },
  'orders.statusReady': { ru: 'Готов', en: 'Ready' },
  'orders.statusCompleted': { ru: 'Завершён', en: 'Completed' },
  'orders.statusCancelled': { ru: 'Отменён', en: 'Cancelled' },
  'orders.actionView': { ru: 'Подробнее', en: 'View' },
  'orders.actionEdit': { ru: 'Изменить', en: 'Edit' },
  'orders.actionMarkReady': { ru: 'Готово', en: 'Mark Ready' },
  'orders.actionDelete': { ru: 'Удалить', en: 'Delete' },
  'orders.noOrders': { ru: 'Нет заказов', en: 'No orders' },
  'orders.loading': { ru: 'Загрузка заказов...', en: 'Loading orders...' },
  'orders.errorLoading': { ru: 'Ошибка загрузки заказов', en: 'Error loading orders' },
  'orders.orderNumber': { ru: 'Заказ', en: 'Order' },
  'orders.source': { ru: 'Источник', en: 'Source' },
  'orders.items': { ru: 'Позиции', en: 'Items' },
  'orders.createdAt': { ru: 'Создан', en: 'Created' },
  'orders.orderDetails': { ru: 'Детали заказа', en: 'Order Details' },
  'orders.customerInfo': { ru: 'Информация о клиенте', en: 'Customer Info' },
  'orders.promoCode': { ru: 'Промокод', en: 'Promo Code' },
  'orders.subtotal': { ru: 'Сумма до скидки', en: 'Subtotal' },
  'orders.close': { ru: 'Закрыть', en: 'Close' },
  'orders.confirmDelete': { ru: 'Удалить заказ?', en: 'Delete order?' },
  'orders.deleteSuccess': { ru: 'Заказ удалён', en: 'Order deleted' },
  'orders.deleteError': { ru: 'Ошибка удаления заказа', en: 'Error deleting order' },

  // Страница добавления заказа
  'addOrder.title': { ru: 'Новый заказ', en: 'New Order' },
  'addOrder.selectSourceSubtitle': { ru: 'Выберите источник заказа', en: 'Select order source' },
  'addOrder.fillFieldsTitle': { ru: 'Заполните поля', en: 'Fill in fields' },
  'addOrder.fillFieldsSubtitle': { ru: 'Введите информацию о заказе', en: 'Enter order information' },
  'addOrder.backToSource': { ru: 'Назад к выбору источника', en: 'Back to source selection' },
  'addOrder.backToFields': { ru: 'Назад к полям', en: 'Back to fields' },
  'addOrder.cancel': { ru: 'Отмена', en: 'Cancel' },
  'addOrder.continue': { ru: 'Продолжить', en: 'Continue' },
  'addOrder.selectOption': { ru: 'Выберите опцию', en: 'Select option' },
  'addOrder.selectDishesTitle': { ru: 'Выберите блюда', en: 'Select Dishes' },
  'addOrder.selectDishesSubtitle': { ru: 'Добавьте блюда в заказ', en: 'Add dishes to order' },
  'addOrder.promoApplied': { ru: 'Промокод применен', en: 'Promo code applied' },
  'addOrder.discount': { ru: 'Скидка', en: 'Discount' },
  'addOrder.promoInvalid': { ru: 'Промокод недействителен', en: 'Promo code invalid' },
  'addOrder.noDishesAvailable': { ru: 'Нет доступных блюд для этого источника', en: 'No dishes available for this source' },
  'addOrder.loadingMenu': { ru: 'Загрузка меню...', en: 'Loading menu...' },
  'addOrder.errorLoadMenu': { ru: 'Не удалось загрузить меню', en: 'Failed to load menu' },
  'addOrder.grams': { ru: 'г', en: 'g' },
  'addOrder.addToOrder': { ru: 'Добавить', en: 'Add' },
  'addOrder.quantity': { ru: 'Количество', en: 'Quantity' },
  'addOrder.selectedItems': { ru: 'Выбранные блюда', en: 'Selected Items' },
  'addOrder.total': { ru: 'Итого', en: 'Total' },
  'addOrder.createOrder': { ru: 'Создать заказ', en: 'Create Order' },
  'addOrder.noItemsSelected': { ru: 'Выберите хотя бы одно блюдо', en: 'Select at least one dish' },
  'addOrder.discountAvailable': { ru: 'Доступна скидка', en: 'Discount available' },
  'addOrder.promoInvalidTitle': { ru: 'Промокод недействителен', en: 'Promo Code Invalid' },
  'addOrder.promoInvalidMessage': { ru: 'Введенный промокод не найден или неактивен. Вы можете продолжить оформление заказа без промокода.', en: 'The entered promo code was not found or is inactive. You can continue placing your order without a promo code.' },
  'addOrder.okay': { ru: 'Хорошо', en: 'Okay' },
  'addOrder.portionsAvailable': { ru: 'граммовок доступно', en: 'portions available' },
  'addOrder.selectPortion': { ru: 'Выберите граммовку', en: 'Select portion' },
  'addOrder.totalPrice': { ru: 'Общая цена', en: 'Total price' },
  'addOrder.addDish': { ru: 'Добавить', en: 'Add' },
  'addOrder.selectedPortions': { ru: 'Выбрано', en: 'Selected' },
  'addOrder.selectedPortionsSuffix': { ru: 'порций', en: 'portions' },
  'addOrder.itemsCount': { ru: 'блюд', en: 'items' },
  'addOrder.viewOrder': { ru: 'К заказу', en: 'View Order' },
  'addOrder.orderDetails': { ru: 'Детали заказа', en: 'Order Details' },
  'addOrder.remove': { ru: 'Удалить', en: 'Remove' },
  'addOrder.promoCodeAvailable': { ru: 'Промокод', en: 'Promo code' },
  'addOrder.promoAppliedToPortion': { ru: 'Промокод применен', en: 'Promo applied' },
  'addOrder.discountAppliedToPortion': { ru: 'Скидка доступна', en: 'Discount available' },
  'addOrder.manualDiscount': { ru: 'Скидка', en: 'Discount' },
  'addOrder.orderCreated': { ru: 'Заказ создан', en: 'Order created' },
  'addOrder.errorCreateOrder': { ru: 'Ошибка создания заказа', en: 'Error creating order' },
  'addOrder.removeFromOrder': { ru: 'Удалить из заказа', en: 'Remove from order' },
};

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

interface LanguageProviderProps {
  children: ReactNode;
}

export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
  const [language, setLanguageState] = useState<Language>(() => {
    const saved = localStorage.getItem('language');
    return (saved === 'en' || saved === 'ru') ? saved : 'ru';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const setLanguage = (lang: Language) => {
    setLanguageState(lang);
  };

  const t = (key: string): string => {
    return translations[key]?.[language] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = (): LanguageContextType => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage должен использоваться внутри LanguageProvider');
  }
  return context;
};
